export default __webpack_public_path__ + "static/whatIsAd-12a1cb0b78d2562a195d7ee443bb63f2.webp";